(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["houston-showroom-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      const carousel = root.querySelector('[data-houston-bike-reviews]');
      const mapElement = root.querySelector('[data-houston-review-products]');
      if (!carousel || !mapElement || carousel.dataset.bikeFilterInitialized) return;
      carousel.dataset.bikeFilterInitialized = 'true';
      let products;
      try { products = new Map(JSON.parse(mapElement.textContent).map((product) => [product.handle, product])); }
      catch (error) { return; }
      const scan = () => {
        let changed = false;
        carousel.querySelectorAll('.swiper-slide').forEach((slide) => {
          const link = slide.querySelector('.kl_reviews__carousel__link');
          if (!link) return;
          let handle;
          try { handle = link.dataset.reviewBikeHandle || new URL(link.href, location.origin).pathname.split('/products/')[1]?.replace(/\/$/, ''); }
          catch (error) { return; }
          const product = products.get(handle);
          if (!product) { slide.remove(); changed = true; return; }
          link.dataset.reviewBikeHandle = handle;
          if (link.getAttribute('href') !== product.url) link.setAttribute('href', product.url);
          const review = link.querySelector('.kl_reviews__carousel__review');
          if (!review || review.querySelector('.houston-showroom__review-bike')) return;
          const media = document.createElement('div');
          media.className = 'houston-showroom__review-bike';
          if (product.image) {
            const image = document.createElement('img');
            image.src = product.image;
            image.alt = product.title;
            image.loading = 'lazy';
            image.decoding = 'async';
            image.width = 720;
            image.height = 480;
            media.append(image);
          }
          const label = document.createElement('span');
          label.textContent = product.title;
          media.append(label);
          review.prepend(media);
          changed = true;
        });
        if (carousel.querySelector('.kl_reviews__carousel__link')) {
          carousel.dataset.bikeReviewsReady = 'true';
        }
        if (changed) requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      };
      new MutationObserver(scan).observe(carousel, {childList: true, subtree: true});
      scan();
    };
    document.querySelectorAll('[data-houston-showroom]').forEach(setup);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-houston-showroom]').forEach(setup);
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
